<template>
  <div class='h-dialogContainer'>
    <div class='h-subscriber-inputLit'>{{$t('SubscriberIms.userNo')}}:</div>
    <ejs-textbox :value='obj.impu' v-model='obj.impu'></ejs-textbox>
    <div class='h-subscriber-inputLit' style="margin-top: 18px">{{$t('SubscriberIms.userName')}}:</div>
    <ejs-textbox :value='obj.username' v-model='obj.username'></ejs-textbox>
    <div v-if='showOption'>
      <div class='h-subscriber-inputLit' style="margin-top: 18px">{{$t('SubscriberIms.userenable')}}:</div>
      <ejs-dropdownlist :fields='fields' :dataSource='options.userenable' v-model='obj.userenable' />
      <div class='h-subscriber-inputLit' style="margin-top: 18px">{{$t('SubscriberIms.rtttype')}}:</div>
      <ejs-dropdownlist :fields='fields' :dataSource='options.rtttype' v-model='obj.rtttype' />
    </div>    
  </div>
</template>

<script>
export default {
  name: 'ImsUserSearchDialog',
  props: [
    'showOption',
  ],
  data() {
    return {
      fields: {
        value: 'value',
        text: 'text'
      },
      options: {
        userenable: [
          {value:-1, text: this.$t('SubscriberIms.pleaseChoose')},
          {value:0, text: this.$t('SubscriberIms.userenable0')},
          {value:1, text: this.$t('SubscriberIms.userenable1')},
        ],
        rtttype: [
          {value:-1, text: this.$t('SubscriberIms.pleaseChoose')},
          {value:1, text: this.$t('SubscriberIms.rtttype1')},
          {value:2, text: this.$t('SubscriberIms.rtttype2')},
          {value:3, text: this.$t('SubscriberIms.rtttype3')},
          {value:4, text: this.$t('SubscriberIms.rtttype4')},
          {value:5, text: this.$t('SubscriberIms.rtttype5')},
          {value:6, text: this.$t('SubscriberIms.rtttype6_2')},
        ]
      },
      obj: {
        impu: '',
        username: '',
        userenable:-1,
        rtttype:-1,
        flag: 2
      }
    };
  },
  methods: {
    getFormValue() {
      return { impu: this.obj.impu, username: this.obj.username, userenable: this.obj.userenable, rtttype: this.obj.rtttype, flag: 2 };
    },
    getData() {
      return this.obj;
    },
    clearData() {
      this.obj = { impu: '', username: '', userenable:-1, rtttype:-1, flag: 2 };
    },
    setData(data) {
      if (data) {
        this.obj = data;
      }
    }
  }
};
</script>

<style scoped>

</style>
